module.exports = __webpack_public_path__ + "static/media/ico-brand.ee8b361b.svg";